export default __webpack_public_path__ + "static/vision03-cfe125835b1d28e61e238ad435b4f6ba.jpg";